import React from "react";
import { Input } from "antd";

const { TextArea } = Input;

export default class TextAera extends React.Component {

    constructor(props) {
        super(props);
        const { id, placeholder, value, max } = props;
        this.state = { value: value, id: id, placeholder: placeholder, max: max };

        this.onChange = this.onChange.bind(this);

    }

    onChange = (event) => {

        this.setState({ value: event.target.value });
        this.props.onChange(event)
    };

    onBlur = (event) => {
        this.props.onChange(event, this.state);
    }

    render() {
        return (<TextArea  size={'large'} allowClear id={this.state.id} maxLength={this.state.max} placeholder={this.state.placeholder} style={{ width: '100%' }} value={this.state.value} onChange={this.onChange} />);
    }
}